import DynamicLink from '@/pages/operation/DynamicLink.vue';
import WebviewManage from '@/pages/operation/WebviewManage';
import WebviewRegister from '@/pages/operation/WebviewRegister';
import WebviewModify from '@/pages/operation/WebviewModify';
import AttendanceStatistics from '@/pages/operation/AttendanceStatistics.vue';
import QnaStatistics from '@/pages/operation/QnaStatistics.vue';
import QnaCategoryStatistics from '@/pages/operation/QnaCategoryStatistics.vue';
import PushStatistics from '@/pages/operation/PushStatistics/index.vue';
import PushStatisticsDetail from '@/pages/operation/PushStatistics/_id.vue';
import ThemeList from '@/pages/operation/ThemeList.vue';
import ThemeRegister from '@/pages/operation/ThemeRegister.vue';
import ThemeUpdate from '@/pages/operation/ThemeUpdate.vue';
import CollectionList from '@/pages/operation/CollectionList.vue';
import CollectionUpdate from '@/pages/operation/CollectionUpdate.vue';
import FAQList from '@/pages/operation/FAQList.vue';
import FAQ from '@/pages/operation/FAQ.vue';
import CsList from '@/pages/operation/CsList.vue';
import Cs from '@/pages/operation/Cs.vue';
import NoticeList from '@/pages/operation/NoticeList.vue';
import Notice from '@/pages/operation/Notice.vue';
import EventStatistics from '@/pages/operation/DataStatisticsList/EventStatistics';
import ReviewStatistics from '@/pages/operation/DataStatisticsList/ReviewStatistics';
import CategoryTop from '@/pages/operation/CategoryTop.vue';
import UserRetention from '@/pages/operation/UserRetention.vue';
import CremaInspectionList from '@/pages/operation/CremaInspectionList.vue';
import CremaSignupList from '@/pages/operation/CremaSignupList.vue';
import Analytics from '@/pages/operation/Analytics.vue';
import CategoryAnalytics from '@/pages/operation/CategoryAnalytics.vue';
import Message from '@/pages/operation/Message.vue';
import MessageRegister from '@/pages/operation/MessageRegister.vue';
import ServiceCheck from '@/pages/operation/ServiceCheck.vue';
import ServiceCheckRegister from '@/pages/operation/ServiceCheckRegister.vue';

export default {
	DynamicLink: {
		id: 'DynamicLink',
		title: '다이나믹링크 생성',
		heading: '다이나믹링크 생성',
		path: '/operation/dynamic-link',
		component: DynamicLink,
		type: 'v3',
	},
	WebviewManage: {
		id: 'WebviewManage',
		title: '웹뷰 화면 관리',
		heading: '웹뷰 화면 관리',
		path: '/operation/webview/list',
		component: WebviewManage,
	},
	WebviewRegister: {
		id: 'WebviewRegister',
		title: '웹뷰 화면 등록',
		heading: '웹뷰 화면 등록',
		path: '/operation/webview/register',
		component: WebviewRegister,
	},
	WebviewModify: {
		id: 'WebviewModify',
		title: '웹뷰 화면 등록',
		heading: '웹뷰 화면 등록',
		path: '/operation/webview/modify/:webviewId',
		component: WebviewModify,
	},
	AttendanceStatistics: {
		type: 'v3',
		id: 'AttendanceStatistics',
		title: '출석체크 통계',
		heading: '출석체크 통계',
		path: '/operation/statistics/attendance',
		component: AttendanceStatistics,
	},
	EventStatistics: {
		type: 'v3',
		id: 'EventStatistics',
		title: '이벤트 통계',
		heading: '이벤트 통계',
		path: '/operation/statistics/event',
		component: EventStatistics,
	},
	ReviewStatistics: {
		type: 'v3',
		id: 'ReviewStatistics',
		title: '리뷰 통계',
		heading: '리뷰 통계',
		path: '/operation/statistics/review',
		component: ReviewStatistics,
	},
	QnaStatistics: {
		type: 'v3',
		id: 'QnaStatistics',
		title: 'Q&A 통계',
		heading: 'Q&A 통계',
		path: '/operation/statistics/qna',
		component: QnaStatistics,
	},
	UserRetention: {
		type: 'v3',
		id: 'UserRetention',
		title: '유저별 리텐셜 통계',
		heading: '유저별 리텐셜 통계',
		path: '/operation/statistics/user-retention',
		component: UserRetention,
	},
	QnaCategoryStatistics: {
		type: 'v3',
		id: 'QnaCategoryStatistics',
		title: 'Q&A 카테고리 통계',
		heading: 'Q&A 카테고리 통계',
		path: '/operation/statistics/qna-category',
		component: QnaCategoryStatistics,
	},
	PushStatistics: {
		type: 'v3',
		id: 'PushStatistics',
		title: '푸시/알림함 통계',
		heading: '푸시/알림함 통계',
		path: '/operation/statistics/push',
		component: PushStatistics,
	},
	PushStatisticsDetail: {
		type: 'v3',
		id: 'PushStatisticsDetail',
		title: '유저별 푸시/알림함 열람 시간',
		heading: '유저별 푸시/알림함 열람 시간',
		path: '/operation/statistics/push/:idNoti',
		component: PushStatisticsDetail,
	},
	ThemeList: {
		type: 'v3',
		id: 'ThemeList',
		title: '테마 리스트',
		heading: '테마 리스트',
		path: '/operation/theme-list',
		component: ThemeList,
	},
	ThemeRegister: {
		type: 'v3',
		id: 'ThemeRegister',
		title: '테마 등록',
		heading: '테마 등록',
		path: '/operation/theme-register',
		component: ThemeRegister,
	},
	ThemeUpdate: {
		type: 'v3',
		id: 'ThemeUpdate',
		title: '테마 수정',
		heading: '테마 수정',
		path: '/operation/theme-update/:idTheme',
		component: ThemeUpdate,
	},
	CollectionList: {
		type: 'v3',
		id: 'CollectionList',
		title: '컬렉션 리스트',
		heading: '컬렉션 리스트',
		path: '/operation/collection-list',
		component: CollectionList,
	},
	CollectionUpdate: {
		type: 'v3',
		id: 'CollectionUpdate',
		title: '컬렉션 수정',
		heading: '컬렉션 수정',
		path: '/operation/collection-update/:idCollection',
		component: CollectionUpdate,
	},
	FAQList: {
		type: 'v3',
		id: 'FAQList',
		title: '자주 묻는 질문',
		heading: '자주 묻는 질문',
		path: '/operation/faq-list',
		component: FAQList,
	},
	FAQ: {
		type: 'v3',
		id: 'FAQ',
		title: '자주 묻는 질문 등록',
		heading: '자주 묻는 질문 등록',
		path: '/operation/faq',
		component: FAQ,
	},
	CsList: {
		type: 'v3',
		id: 'CsList',
		title: '1:1 문의',
		heading: '1:1 문의',
		parentName: '고객지원',
		path: '/operation/cs-list',
		component: CsList,
	},
	Cs: {
		type: 'v3',
		id: 'Cs',
		title: '1:1 문의 상세정보',
		heading: '1:1 문의 상세정보',
		parentName: '고객지원',
		path: '/operation/cs/:csId',
		component: Cs,
	},
	NoticeList: {
		type: 'v3',
		id: 'NoticeList',
		title: '공지사항',
		heading: '공지사항',
		parentName: '고객지원',
		path: '/operation/notice-list',
		component: NoticeList,
	},
	Notice: {
		type: 'v3',
		id: 'Notice',
		title: '공지사항 등록',
		heading: '공지사항 등록',
		parentName: '고객지원',
		path: '/operation/notice',
		component: Notice,
	},
	CategoryTop: {
		id: 'CategoryTop',
		title: '카테고리 조회수 TOP',
		heading: '카테고리 조회수 TOP',
		path: '/operation/category-top',
		component: CategoryTop,
	},
	CremaInspectionList: {
		type: 'v3',
		id: 'CremaInspectionList',
		title: '크리마 검수 요청 내역',
		heading: '크리마 검수 요청 내역',
		path: '/operation/crema-inspection-list',
		component: CremaInspectionList,
	},
	CremaSignupList: {
		type: 'v3',
		id: 'CremaSignupList',
		title: '크리마 계정 신청 내역',
		heading: '크리마 계정 신청 내역',
		path: '/operation/crema-signup-list',
		component: CremaSignupList,
	},
	Analytics: {
		id: 'Analytics',
		title: '통계관리',
		heading: '통계관리',
		path: '/operation/analytics',
		component: Analytics,
	},
	CategroyAnalytics: {
		id: 'CategroyAnalytics',
		title: '카테고리 통계',
		heading: '카테고리 통계',
		path: '/operation/category-analytics',
		component: CategoryAnalytics,
	},
	Message: {
		id: 'Message',
		title: '메시지 관리',
		heading: '메시지 관리',
		path: '/operation/message',
		component: Message,
	},
	MessageRegister: {
		id: 'MessageRegister',
		title: '메시지 등록',
		heading: '메시지 등록',
		path: '/operation/message-register',
		component: MessageRegister,
	},
	ServiceCheck: {
		id: 'ServiceCheck',
		title: '서비스 점검 관리',
		heading: '서비스 점검 관리',
		path: '/operation/service-check',
		component: ServiceCheck,
	},
	ServiceCheckRegister: {
		id: 'ServiceCheckRegister',
		title: '서비스 점검 등록',
		heading: '서비스 점검 등록',
		path: '/operation/service-check-register',
		component: ServiceCheckRegister,
	},
	ServiceCheckModify: {
		id: 'ServiceCheckModify',
		title: '서비스 점검 수정',
		heading: '서비스 점검 수정',
		path: '/operation/service-check-modify/:idServiceCheck',
		component: ServiceCheckRegister,
	},
};
